module.exports = __webpack_public_path__ + "static/media/22ESCWA3.10954e34.jpg";